import React from 'react';
import PropTypes from 'prop-types';
import BasicButton from '../../../../../../components/BasicButton';
import BasicButtonGroup from '../../../../../../components/BasicButtonGroup';
import BasicSubmitButton from '../../../../../../components/BasicSubmitButton';

const Controls = props => {
  const { onSubmit, onClose, submitBtnText } = props;

  return (
    <div className="form__controls form__controls--compact">
      <BasicButtonGroup>
        <BasicSubmitButton
          controlFunc={onSubmit}
          btnWidth={200}
          btnHeight={40}
          btnFontWeight={500}
          btnFontSize="0.8571rem"
          btnArrow={true}
          btnTextColor="#27282d"
          btnText={submitBtnText}
        />

        <BasicButton
          controlFunc={onClose}
          btnWidth={200}
          btnHeight={40}
          btnFontWeight={500}
          btnFontSize="0.8571rem"
          btnArrow={false}
          btnTextColor="#27282d"
          btnText="Cancel"
        />
      </BasicButtonGroup>
    </div>
  );
};

Controls.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  submitBtnText: PropTypes.string.isRequired,
};

export default Controls;
